import React from "react";

const HowItWorks = () => {
  const steps = [
    {
      id: 1,
      title: "Sign Up as a Company",
      description:
        "Create your company account in minutes. Verify your business and get access to our platform with full features.",
    },
    {
      id: 2,
      title: "Create Your Surveys",
      description:
        "Use our intuitive builder to create your surveys. Set targeting criteria and launch to our engaged user base.",
    },
    {
      id: 3,
      title: "Collect Feedback & Grow",
      description:
        "Watch responses come in real-time. Analyze data with our tools and make informed business decisions.",
    },
  ];

  return (
    <section className="py-16 px-6 lg:px-12 bg-gradient-to-b from-blue-50 to-indigo-50 font-sans">
      <div className="max-w-6xl mx-auto text-center">
        {/* Heading */}
        <h2 className="text-3xl md:text-4xl font-bold text-gray-800">
          How It Works
        </h2>
        <p className="text-gray-500 mt-2 mb-12">
          Get started with SurveysIQ in three simple steps
        </p>

        {/* Steps Grid */}
        <div className="grid grid-cols-1 md:grid-cols-3 gap-12 mx-auto">
          {steps.map((step) => (
            <div
              key={step.id}
              className="flex flex-col items-center text-center space-y-4 max-w-xs mx-auto"
            >
              {/* Circle Number */}
              <div className="flex items-center justify-center w-12 h-12 rounded-full bg-green-600 text-white font-bold shadow-md">
                {step.id}
              </div>

              {/* Title */}
              <h3 className="text-2xl font-semibold text-gray-800">
                {step.title}
              </h3>

              {/* Description */}
              <p className="text-gray-500 text-[16px]">{step.description}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default HowItWorks;
